import { SAMessageType } from "@missionlabs/smartagent-chat-components-lib/dist/ChatMessage/chat-message.types";
import { IChatMessage } from "store/messages/messages.state";
import { ChatBanner } from "@missionlabs/smartagent-chat-components-lib";
import { isBanner } from "utils";

const useRenderBanner = () => {
    const renderBanner = (messages: IChatMessage[]) => {
        return messages
            .filter((msg) => isBanner(msg))
            .map((bannerMessage) => (
                <ChatBanner
                    bannerId={bannerMessage.id}
                    content={bannerMessage.content as SAMessageType}
                    isHTMLEnabled={false}
                    isMarkdownEnabled={true}
                />
            ));
    };

    return renderBanner;
};

export default useRenderBanner;
